





























































































































































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import EstadoDeCuenta2 from '@/components/condominios/EstadoDeCuenta2.vue';
// import Liquidacion from '@/components/condominios/Liquidacion.vue';
import Contactos from '@/components/propietarios/Contactos.vue';
import ReporteGeneralMensual2 from '@/components/condominios/ReporteGeneralMensual2.vue';
import ReporteGeneralMensual from '@/components/condominios/ReporteGeneralMensual.vue';

export default Vue.extend({
  components: { EstadoDeCuenta2, Contactos, ReporteGeneralMensual2, ReporteGeneralMensual},
  data: () => ({
    disabled: true,
    dialogAviso: false,
    dialogCuenta: false,
    menuInicial: false,
    menuFinal: false,
    formatoFecha: 'DD/MM/YYYY',
    dateInicial: '',
    dateFinal: '',
    singleSelect: false,
    row: null,
    selected: [],
    headers: [
      { text: 'Unidad', value: 'nombreUnidad', sortable: false },
      // { text: 'unidadId', value: 'unidadId' },
      { text: 'Inquilino/Propietario', value: 'nombreInquilino', sortable: false  },
      { text: 'Activo', value: 'estaActivo', sortable: false  },
      { text: 'Saldo', value: 'saldo', sortable: false  },
      { text: 'Saldo A Favor', value: 'saldoF', sortable: false},
    ],
    total: 0,
    Unidades: [],
    loading: true,
    options: { page: 1, itemsPerPage: 100 },
    dialog: false,
    Condominio: {},
    propietario: [],
    Datos: {
      admin: '',
      condo: '',
    },
    aviso: {
      periodoFinal: '',
      periodoInicio: '',
      unidades: [],
      saldos: [],
    },
    unidades: {id: 0, saldo: 0},
    isSelectedUnique: false,
    isSelectedEmpty: false,
  }),
  computed: {
    DateIni() {
      return this.$moment(this.Condominio.inicio).format(this.formatoFecha);
    },
    DateFin() {
      return this.$moment(this.Condominio.fin).format(this.formatoFecha);
    },
    computedDateIFormatted() {
      return this.$moment(this.dateInicial).format(this.formatoFecha);
    },
    computedDateFFormatted() {
      return this.$moment(this.dateFinal).format(this.formatoFecha);
    },
    DateFormatted() {
      return this.$moment(this.dateInicial).endOf('month').format();
    },
  },
  mounted() {
    // this.loadData();
    this.fechas();
  },
  methods: {
    fechas() {
      this.dateInicial = this.$moment().startOf('month').format();
      this.dateFinal = this.$moment().endOf('month').format();
    },
    ...mapActions(['getUnidadesPropList']),
    open(event) {
      console.log('Current:', event);
      this.Condominio = event;
      const prop = {
        id: event.propId,
        nombre: event.nombreInquilino,
      };
      this.propietario = [prop];
      this.dialog = true;
    },
    rowSelected(event) {
      this.open(event);
    },
    async generaAvisos() {
      this.aviso.periodoInicio = this.$moment(this.dateInicial).format();
      this.aviso.periodoFinal = this.$moment(this.dateFinal).format();
      for (const ids of this.selected) {
        this.aviso.unidades.push(ids.id);
        this.aviso.saldos.push(ids.saldo);
      }
      console.debug('Avisos: %o', this.aviso);
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const avisos = this.aviso;
        const datos = {admin, condo, avisos};
        console.log('addLoteAvisos datos: %o', datos);
        const response = await this.$store.dispatch('addLoteAvisos', {admin, condo, avisos});
        console.log('addLoteAvisos response: %o', response);
        this.$toast.success('Avisos agregados exitosamente');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.closeDialog();
    },
    async loadData() {
      try {
        this.loading = true;
        this.Datos.admin = this.$store.getters.getAdmin;
        this.Datos.condo = this.$store.getters.getCondo;
        this.Datos.condo = await this.$store.dispatch('getCondoById', this.Datos);
        console.debug('getUnidadesPropList datos: %o %o', this.Datos, this.options);
        const result = await this.$store.dispatch('getUnidadesPropList', {datos: this.Datos, options: this.options});
        console.debug('getUnidadesPropList response: ', result);
        result.content.forEach(this.getSaldo);
        result.content.forEach(this.getSaldoFavor);
        this.Unidades = result.content;
        this.total = result.totalElements;
        this.addUniPropKeys(this.Unidades);
        // console.debug('Unidad: %o', this.Unidades);
        console.log('Unidad--: %o', this.Unidades);
        this.selected = [];
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.selected = [],
      this.loadData();
    },
    addUniPropKeys(uniPropArray) {
      for (const uniProp of uniPropArray) {
        const key = 'unidad' + uniProp.unidadId + 'propietario' + uniProp.propId;
        uniProp.key = key;
      }
    },
    closeDialog() {
      this.$emit('reload', {});
      this.aviso = this.nuevoAviso();
      this.fechas();
      this.dialogAviso = false;
    },
    nuevoAviso() {
      return {
          periodoInicio: '',
          periodoFinal: '',
          unidades: [],
          saldos: [],
      };
    },
    getSaldo(unidad, idx) {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const datos = {admin, condo, unidad, x: 0};
      const saldo = this.$store.dispatch('getUnidadSaldo', datos)
        .then((result) => {
              unidad.saldo = result.saldo;
          //  console.log('Saldo: %o', unidad.saldo);
              })
        .catch((e) => console.log(unidad.nombreUnidad + ': ' + e.response.data.message));
    },
    getSaldoFavor(unidad, idx) {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const datos = {admin, condo, unidad, x: 1};
      const saldo = this.$store.dispatch('getUnidadSaldo', datos)
        .then((result) => {
              unidad.saldoF = result.saldo * -1;
          //  console.log('Saldo: %o', unidad.saldo);
              })
        .catch((e) => console.log(unidad.nombreUnidad + ': ' + e.response.data.message));
    },
  },
  watch: {
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.isSelectedUnique = true;
        this.isSelectedEmpty = true;
      } else {
        if (this.selected.length === 1) {
          this.isSelectedUnique = false;
          this.isSelectedEmpty = false;
        } else {
          this.isSelectedUnique = true;
          this.isSelectedEmpty = false;
        }
      }
    },
  },
});
